import React, { useContext, useState } from 'react'
import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Input from '../Input'
import Select from '../Select';
import { BigHead } from '@bigheads/core'
import { CartsContext } from '../../context/cart';

const CardInput = styled.section`

    display: flex;
    width: 90%;
    margin: 0 auto;
    margin-bottom: 0.9em;


    input,select{
        width: 100%;
        height: 50px;
        border-radius: 10px;
    }

    div > label{
        font-size: 0.9rem;
    }

    .textPrimary{
        color: black;
        font-family: "Poppins";
        font-weight: 500;
        margin-bottom: 0rem;
        font-size: 1.1rem;
    }

    div{
        margin-left:1.5rem;
    }

    @media screen and (max-width:720px){
        flex-direction: column;

        div{
            margin-left: 0rem;
            margin-top: 0.5rem;
        }

    }


`
const CardWrapper = styled.section`
    display: flex;
    flex-direction: column;

`
const ImagePreview = styled.div`
    width: 150px;
    height: 150px;
    margin: 0 auto;
    object-fit: contain;
    border-radius: 100px;
`
const ImagePreviewProduct = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 170px;
    margin: 1.5rem auto;
    object-fit: contain;
    border-radius: 100px;

    img{
        border-radius: 100px;
        border: 1px solid #dddddd;
        width: 150px;
        height: 150px;
    }

    p{
        font-family: "Poppins";
        font-weight: 600;
        height: 68px;
    }

`
const UserImage = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 1.1rem;
    font-family: "Poppins";
    font-weight: 500;

    p{  
        font-size: 1.1rem;
        text-align: center;
        margin-top: 0.5rem;
    }

    @media screen and (max-width:820px){

        
    }

`

const ModalRequestCart = ({ props }) => {

    const { cartRequest,userData } = useContext(CartsContext)


    const handleAddClick = () => {
        props.onHide(); // Fechar a modal após adicionar
    }

    return (

        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered

        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Detalhes do carrinho
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <CardWrapper>

                    <ImagePreview>
                        <BigHead
                            accessory="shades"
                            body="chest"
                            circleColor="blue"
                            clothing="tankTop"
                            clothingColor="black"
                            eyebrows="angry"
                            eyes="wink"
                            facialHair="mediumBeard"
                            graphic="vue"
                            hair="short"
                            hairColor="black"
                            hat="none"
                            hatColor="green"
                            lashes="false"
                            lipColor="purple"
                            mask="true"
                            faceMask="true"
                            mouth="open"
                            skinTone="brown"
                        />
                    </ImagePreview>
                    <UserImage>

                        <p>{cartRequest?.user_name}</p>
                    </UserImage>
                    <CardInput>
                        <div style={{ width: "100%" }}><p className='textPrimary'>Dados do cliente</p></div>
                        <div style={{ width: "100%" }}></div>
                    </CardInput>

                    <CardInput>
                        <Input name={"Nome "} value={cartRequest?.user_name} />
                        <Input name={"CPF "} value={cartRequest?.cpf} />
                    </CardInput>

                    <CardInput>
                        <Input name={"Celular "} value={userData?.phone} />
                        <Input name={"Email "}  value={userData?.mail}/>
                    </CardInput>

                    <CardInput>
                        <div style={{ width: "100%" }}><p className='textPrimary'>Dados de endereço</p></div>
                        <div style={{ width: "100%" }}></div>
                    </CardInput>
                    <CardInput>
                        <Input name={"Rua "} value={cartRequest?.street} />
                        <Input name={"Número "} value={cartRequest?.number} />
                    </CardInput>

                    <CardInput>
                        <Input name={"Cep "} value={cartRequest?.zipCode} />
                        <Input name={"Complemento "} value={cartRequest?.complement} />
                    </CardInput>

                    <CardInput>
                        <Input name={"Estado "} value={cartRequest?.state} />
                        <Input name={"Cidade "} value={cartRequest?.city} />
                    </CardInput>


                    <ImagePreviewProduct>
                        <img src={cartRequest?.products[0].product_image} />
                        <p>{cartRequest?.products[0].name}</p>
                    </ImagePreviewProduct>

                    <CardInput>
                        <div style={{ width: "100%" }}><p className='textPrimary'>Dados do pedido</p></div>
                        <div style={{ width: "100%" }}></div>
                    </CardInput>

                    <CardInput>
                        <Input name={"Produto "} value={cartRequest?.products[0].name} />
                        <Input name={"Quantidade "} value={`${cartRequest?.products[0].quantity} X`} />
                    </CardInput>
                    <CardInput>
                        <Input name={"Preço "} value={Number(cartRequest?.products[0].price).toLocaleString("pt-BR",{minimumFractionDigits:2})} />
                        <Input name={"Marca "} value={`${cartRequest?.products[0].category}`} />
                    </CardInput>

                </CardWrapper>

            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => handleAddClick()}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalRequestCart